module.exports = __webpack_public_path__ + "img/plan2M.5bd4d6cc.png";